import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assets/scss/style.scss";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/pagination'
import 'driver.js/dist/driver.css';
import './i18n'


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
    <React.StrictMode>
        <App />
        <ToastContainer/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
